import { isAgentState } from './isAgentState';
import { AWAY } from '../constants/AgentStates';
export const isAway = isAgentState(AWAY);